import { render } from "./ConfirmModal.vue?vue&type=template&id=658d2440"
import script from "./ConfirmModal.vue?vue&type=script&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrii/Documents/Projects/optometry-academy-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__